module.exports = __webpack_public_path__ + "static/media/balance_reset.848741a0.svg";